import { Component } from '@angular/core';
import { AuthService } from '../../Auth/auth.service';
import { Router } from '@angular/router';
import { DataService } from '../../Services/Data Service/data.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css'
})
export class UnauthorizedComponent {

  constructor(private authService: AuthService, private router: Router, private dataService: DataService){}
  
  handleLogout(event: Event): void {
    event.preventDefault(); // Prevent page reload or unwanted navigation
    this.dataService.setCurrentUser(null);
    this.authService.logout(); // Call logout function
  }
}
